import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  getAppoinmentAction,
  getAppointmentQueueFilterCountsAction,
  getStatusReasonAction,
  updateAppoinmentStatusAction,
  updateRejectStatusAction,
} from "../../../redux/actions/AppoinmentAction";
import { getDispatch } from "../../../Utils/helper";
import { IS_SHOW_POPUP } from "../../../Utils/types";
import { ReasonTypeHAPortal, ReasonTypeHAProduct } from "./helper";
import { useState } from "react";

export const ConfirmationPopup = ({
  isConfirmationPopup,
  setIsConfirmationPopup,
  searchFilter,
  apiParams,
}) => {
  const dispatch = useDispatch();
  const [statusType, setStatusType] = useState(0);

  const appoinmentReducer = useSelector((state) => state?.AppoinmentReducer);

  const temp = {
    appointmentId: isConfirmationPopup?.cardDetails?.appointmentId,
    isApproved: "true",
    target: isConfirmationPopup?.cardDetails?.valueType,
    remarks: "",
    timeSlot: moment(
      isConfirmationPopup?.cardDetails?.appointmentDateTime
    ).format("YYYY-MM-DD hh:mm A"),
    availableTimeSlots: "",
    validate: false,
    AppointmentStatusId: isConfirmationPopup?.cardDetails?.appointmentstatusid,
  };

  const handleClose = () => {
    setIsConfirmationPopup(null);
    getDispatch(IS_SHOW_POPUP, false, dispatch);
    setStatusType(0);
  };

  return (
    <>
      <div className="modal-body modal-body-active-popup popup-text">
        {isConfirmationPopup?.message}
      </div>
      {isConfirmationPopup?.DCConfirmationFlag === "N" && (
        <div className="confirm_select_dropdown">
          <select
            className="form-select-admin"
            style={{ fontFamily: "Poppins" }}
            onChange={(e) => {
              setStatusType(0);
              dispatch(
                getStatusReasonAction({
                  statusName: e.target.value ? e.target.value : null,
                  valueType: isConfirmationPopup?.cardDetails?.valueType,
                })
              );
            }}
          >
            <option value="">Reason Type</option>
            {isConfirmationPopup?.cardDetails?.valueType === "PORTAL"
              ? ReasonTypeHAPortal?.map((ele, index) => {
                  return (
                    <option key={index} value={ele}>
                      {ele}
                    </option>
                  );
                })
              : ReasonTypeHAProduct?.map((ele, index) => {
                  return (
                    <option key={index} value={ele}>
                      {ele}
                    </option>
                  );
                })}
          </select>
          <select
            className="form-select-admin"
            style={{ fontFamily: "Poppins", width: "100%" }}
            value={statusType}
            onChange={(e) => setStatusType(e.target.value)}
          >
            <option value={0}>Status Type</option>
            {appoinmentReducer?.getStatusReason?.map((ele, index) => {
              return (
                <option key={index} value={ele?.statusId}>
                  {ele?.statusName}
                </option>
              );
            })}
          </select>
        </div>
      )}
      <div className="modal-footer modal-footer-active-popup">
        <button
          type="button"
          className="btn btn-primary noshow_disable"
          onClick={async () => {
            if (isConfirmationPopup?.DCConfirmationFlag === "A") {
              await dispatch(updateRejectStatusAction(temp));
            } else {
              await dispatch(
                updateAppoinmentStatusAction({
                  valueType: isConfirmationPopup?.cardDetails?.valueType,
                  appointmentId:
                    isConfirmationPopup?.cardDetails?.appointmentId,
                  DCConfirmationFlag: isConfirmationPopup?.DCConfirmationFlag,
                  validate: false,
                  AppointmentDate: moment(
                    isConfirmationPopup?.cardDetails?.appointmentDateTime
                  ).format("YYYY-MM-DD hh:mm A"),
                  AppointmentStatusId:
                    isConfirmationPopup?.cardDetails?.appointmentstatusid,
                  RemarkId: statusType,
                })
              );
              setStatusType(0);
            }
            setTimeout(()=>{
               dispatch(
                getAppoinmentAction({ ...searchFilter, ...apiParams })
              );
              dispatch(getAppointmentQueueFilterCountsAction({ ...searchFilter, ...apiParams }))
            },1000)
            await handleClose();
          }}
          style={{ width: "90px" }}
          disabled={
            isConfirmationPopup?.DCConfirmationFlag === "N" && statusType == 0
          }
        >
          Yes
        </button>
        <button
          type="button"
          className="btn btn-primary btn-logout-no"
          onClick={handleClose}
        >
          No
        </button>
      </div>
    </>
  );
};
